import { Progress } from "@/components/ui/progress";
import { useTranslation } from "react-i18next";

function fmtBytes(b) {
  if (b == null) return "";
  const units = ["B", "KB", "MB", "GB"];
  let v = b;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(v >= 100 || i === 0 ? 0 : 1)} ${units[i]}`;
}

function fmtEta(s, t) {
  if (s == null || !isFinite(s)) return "…";
  if (s < 60) return t("uploadProgress.etaSec", { s: Math.ceil(s) });
  return t("uploadProgress.etaMin", { m: Math.floor(s / 60), s: Math.ceil(s % 60) });
}

export function UploadProgress({ progress }) {
  const { t } = useTranslation();
  if (!progress) return null;
  const { percent, loaded, total, speed, eta } = progress;
  return (
    <div className="space-y-1.5 rounded-md border border-slate-200 bg-slate-50 p-3" data-testid="upload-progress">
      <div className="flex items-center justify-between text-xs text-slate-600">
        <span className="font-medium" data-testid="upload-progress-label">{t("uploadProgress.uploading", { percent })}</span>
        <span className="font-mono" data-testid="upload-progress-bytes">{fmtBytes(loaded)} / {fmtBytes(total)}</span>
      </div>
      <Progress value={percent} className="h-2" />
      <div className="flex items-center justify-between font-mono text-[11px] text-slate-500">
        <span data-testid="upload-progress-speed">{fmtBytes(speed)}/s</span>
        <span data-testid="upload-progress-eta">{fmtEta(eta, t)}</span>
      </div>
    </div>
  );
}
